
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_18389_13975)"}},[_c('path',{attrs:{"d":"M8.593 7.4c-1.186-.393-1.76-.64-1.76-1.267 0-.68.74-.926 1.207-.926.873 0 1.193.66 1.267.893l1.053-.447c-.1-.3-.547-1.28-1.693-1.493v-.827H7.333v.84c-1.653.374-1.66 1.907-1.66 1.974 0 1.513 1.5 1.94 2.234 2.206 1.053.374 1.52.714 1.52 1.354 0 .753-.7 1.073-1.32 1.073-1.214 0-1.56-1.247-1.6-1.393L5.4 9.833c.42 1.46 1.52 1.854 1.933 1.974v.86h1.334v-.827c.266-.06 1.933-.393 1.933-2.147 0-.926-.407-1.74-2.007-2.293zM2 14H.667v-4h4v1.333H3.013A5.988 5.988 0 008 14a6 6 0 006-6h1.333A7.33 7.33 0 018 15.333a7.334 7.334 0 01-6-3.113V14zM.667 8A7.33 7.33 0 018 .667a7.334 7.334 0 016 3.113V2h1.333v4h-4V4.667h1.654A6 6 0 002 8H.667z","fill":"currentColor"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_18389_13975"}},[_c('rect',{attrs:{"fill":"#fff"}})])])])
          )
        }
      }
    